import { useCallback, useEffect, useState } from 'react'
import { fetchInvestmentGovernancePosition } from './api'

export default function useInvestmentGovernancePosition() {
  const [state, setState] = useState({ data: null, error: null, loading: true, status: 'loading', reason: null })
  const load = useCallback(() => {
    setState({ data: null, error: null, loading: true, status: 'loading', reason: null })
    return fetchInvestmentGovernancePosition()
      .then((data) => {
        if (data?.schema_version !== 1) {
          setState({ data: null, error: 'The governance evidence schema is not supported.', loading: false, status: 'unavailable', reason: 'UNSUPPORTED_SCHEMA' })
          return
        }
        setState({ data, error: null, loading: false, status: 'ready', reason: null })
      })
      .catch((requestError) => {
        const forbidden = requestError?.response?.status === 403
        setState({
          data: null,
          error: forbidden
            ? 'You do not have access to organization-wide governance evidence.'
            : 'Live governance evidence could not be loaded. The Governance Path remains available.',
          loading: false,
          status: forbidden ? 'unavailable' : 'error',
          reason: forbidden ? 'FORBIDDEN' : 'REQUEST_FAILED',
        })
      })
  }, [])

  useEffect(() => { load() }, [load])
  return { ...state, refresh: load }
}
